import { Checkbox, IconButton } from "@mui/material";
import { useStyles } from "./RCAActionPlanTaskItem.styles";
import { IRCAActionPlanTaskItem } from "./RCAActionPlanTaskItemInterfaces";
import DeleteIcon from "@mui/icons-material/Delete";
import useRolesPermissions from "hooks/useRolesPermissions";

const RCAActionPlanTaskItem = ({ task, onCompleteTask, onDeleteTask }: IRCAActionPlanTaskItem) => {
    const classes = useStyles();
    const { RCA_PERMISSIONS } = useRolesPermissions();

    return (
        <div className={classes.actionPlanTaskItemWrapper}>
            <div className={classes.leftContent}>
                <Checkbox
                    checked={task.completed_at !== null}
                    disabled={!RCA_PERMISSIONS?.action_plans.canEdit}
                    color="info"
                    onClick={() => {
                        onCompleteTask(task);
                    }}
                />
                <span
                    style={{
                        textDecoration: task.completed_at ? "line-through" : "none",
                    }}
                >
                    {task.description}
                </span>
            </div>
            <IconButton
                disabled={task.completed_at !== null || !RCA_PERMISSIONS?.action_plans.canEdit}
                onClick={() => {
                    onDeleteTask(task);
                }}
            >
                <DeleteIcon />
            </IconButton>
        </div>
    );
};

export default RCAActionPlanTaskItem;
